import React from 'react';

import { InputAction, UndoIcon } from '@gogame/components';
import {
  dateFNS,
  fromTimeZoneToUTC,
  toISOString,
  fromUTCToTimeZone,
  toDate,
} from '@gogame/intl-ts';

import {
  useFiltersStateManager,
  isEqualFilterValues,
} from '../FiltersStateManager';

const getPrevious = (value, timeZone = 'utc') => {
  if (!value) {
    return;
  }

  const normalizedValue = toDate(value);

  let [start, end] = fromUTCToTimeZone(normalizedValue, timeZone);

  if (dateFNS.isFirstDayOfMonth(start) && dateFNS.isLastDayOfMonth(end)) {
    const prevMonth = dateFNS.subMonths(start, 1);
    start = dateFNS.startOfMonth(prevMonth);
    end = dateFNS.endOfMonth(prevMonth);
  } else {
    const diff = Math.abs(dateFNS.differenceInDays(start, end)) + 1;
    start = dateFNS.subDays(start, diff);
    end = dateFNS.subDays(end, diff);
  }

  return toISOString(fromTimeZoneToUTC([start, end], timeZone));
};

const CompareToPreviousPeriod = ({
  path,
  basePath,
  fontSize,
  onSetValues,
  getPathByName,
}) => {
  const { getFilterValue, getFilterValues, setFilterValue, setFilterValues } =
    useFiltersStateManager();

  const baseValue = getFilterValue(basePath);
  const value = getFilterValue(path);

  const prevToBase = getPrevious(baseValue);

  const handleCompareToPrevious = () => {
    if (onSetValues) {
      const values = getFilterValues();
      setFilterValues(
        onSetValues({ getPathByName, values, value: prevToBase })
      );
    } else {
      setFilterValue(path, prevToBase);
    }
  };

  const comparedToPrevious =
    baseValue === undefined || isEqualFilterValues(prevToBase, value);

  return (
    <InputAction
      icon={<UndoIcon />}
      tooltip={'Compare to previous period'}
      onClick={handleCompareToPrevious}
      disabled={comparedToPrevious}
      fontSize={fontSize}
    />
  );
};

export default CompareToPreviousPeriod;
